<template>
    <b-row>
        <b-col cols="12"
               lg="3">
            <p>{{ inputLabel }}</p>
        </b-col>
        <b-col cols="12"
               lg="4">
            <div class="form-item form-item-text">
                <div class="select-outer">
                    <input type="hidden"
                           :name="'security_' + paramKey"
                           value="this.settingId">
                    <input type="text"
                           :id="paramKey"
                           :name="paramKey"
                           v-model="label"
                           @click="openList = true"
                           @focus="openList = true"
                           @blur="openList = hoverList ? true : false"
                           v-validate
                           data-vv-rules="required"
                           :readonly="true">
                    <ul v-show="openList">
                        <li v-for="(value, index) in list"
                            @click="onChange(value, index), openList = false"
                            @mouseover="hoverList = true"
                            @mouseleave="hoverList = false">{{ value }}</li>
                    </ul>
                </div>
            </div>
        </b-col>
        <save-settings v-if="confirmation.visibility"
                       :action-error="fail"
                       :action-success="setSelected"
                       :action-success-params="confirmation.params"
                       :confirmation-type="settingValue"
                       :message="'Are you sure you want to change the settings?'"
                       :settings="confirmation.settings"></save-settings>
    </b-row>
</template>

<script>
    import SaveSettings from '../../../modals/SaveSettings';
    export default {
        dependencies: ['api', 'popup', 'settings'],
        components: { SaveSettings },
        props: ['inputLabel', 'list', 'paramKey', 'paramLabel', 'paramName', 'paramSettingsName'],
        data () {
            return {
                label: '',
                selected: '',
                token: '',
                openList: false,
                hoverList: false,
                confirmation: {
                    params      : {},
                    type        : '',
                    visibility  : false,
                }

            }
        },
        computed: {
            settingId () {
                return this.$store.getters.settings.confirmations ? this.$store.getters.settings.confirmations[this.paramName].id : false
            },
            settingName () {
                return this.$store.getters.settings.confirmations ? this.$store.getters.settings.confirmations[this.paramName].name : ''
            },
            settingValue () {
                return this.$store.getters.settings.confirmations ? this.$store.getters.settings.confirmations[this.paramName].value : ''
            },
            settingWatcher () {
                return this.$store.getters.settings
            },
        },
        methods: {
            /**
             * Fail action during save settings
             */
            fail (error, params) {
                if (!error) {
                    this.confirmation.visibility = false;
                    this.$forceUpdate();
                } else {
                    switch (error) {
                        case 404:
                            this.confirmation.visibility = false;
                            this.onChange(params.value, params.index);
                            break;
                    }
                }
            },

            /**
             * Action on change option in select
             */
            onChange (value, index) {
                let currentChoice   = this.settingValue,
                    newChoice       = index;

                if (currentChoice === newChoice) return;

                if (currentChoice !== 'NOT_CONFIGURED') {
                    this.$http.get(this.api.token.generate(this.paramSettingsName))
                        .then(() => {
                            this.showModal(value, index, currentChoice);
                        }, () => {
                            this.popup.show('An error occurred.');
                        });
                } else {
                    this.showModal(value, index, false);
                }
            },

            /**
             * Show modal with token
             * @param value
             * @param index
             * @param type
             */
            showModal (value, index, type) {
                this.confirmation = {
                    params      : {
                        value: value,
                        index: index
                    },
                    settings    : this.paramSettingsName,
                    type        : type,
                    visibility  : true
                };
            },

            /**
             * Set selected option and save
             */
            setSelected (params, token) {
                let oldLabel    = this.label,
                    oldSelected = this.selected;
                return new Promise ((resolve, reject) => {
                    this.label      = params.value;
                    this.selected   = params.index;
                    this.token      = token;

                    this.setTemporarySetting();
                    this.settings.create();
                    this.settings.save().then(() => {
                        this.token      = '';
                        resolve();
                    }, () => {
                        this.label      = oldLabel;
                        this.selected   = oldSelected;
                        this.token      = '';
                        reject();
                    });
                });
            },

            /**
             * Set temporary settings
             */
            setTemporarySetting () {
                this.$store.commit('setTemporarySetting', {
                    id: this.settingId,
                    name: this.settingName,
                    value: this.selected,
                    token: this.token
                });
            }
        },
        mounted() {
            if (this.$store.getters.settings.confirmations) {
                this.label = this.list[this.$store.getters.settings.confirmations[this.paramName].value];
                this.selected = this.$store.getters.settings.confirmations[this.paramName].value;
            }
        },
        watch: {
            settingWatcher () {
                this.label = this.$store.getters.settings.confirmations ? this.list[this.$store.getters.settings.confirmations[this.paramName].value] : '';
                this.selected = this.$store.getters.settings.confirmations ? this.$store.getters.settings.confirmations[this.paramName].value : '';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/profile/security/Param.vue